<button #openButton mat-button class="open-button" (click)="openBar()">
    <div fxLayoutGap="5px" class="button-label">
        <span class="material-icons-outlined" [matTooltip]="'Filtrar' | translate">filter_alt</span>
    </div>
</button>

<div class="theme-options-panel-overlay" #overlay [fxHide]="barClosed" [@fadeInOut]="!barClosed"></div>

<div #panel class="theme-options-panel mat-white-bg ">
    <div class="filter-header">
        <span>{{ "Buscar" | translate }}</span>

        <span (click)="closeBar()" style="cursor: pointer" class="material-icons-outlined">highlight_off</span>
    </div>


    <div class="theme-options-panel-inner" fxLayout="column" fxLayoutAlign="start start">
        <ng-content></ng-content>
    </div>
</div>